"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var instantDiscountApi = _interopRequireWildcard(require("@/api/instantDiscountApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      constants: this.$constants,
      visible: false,
      title: '操作日志',
      currentActivityId: null,
      listLoading: false,
      listData: {
        list: [],
        total: 0
      },
      searchPram: {
        opType: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      dateRange: []
    };
  },
  methods: {
    /**
     * 父组件调用入口
     * @param {number} activityId
     * @param {string} activityName 列表标题展示
     */
    openInit: function openInit(activityId, activityName) {
      this.currentActivityId = activityId;
      this.title = activityName ? "\u64CD\u4F5C\u65E5\u5FD7 - ".concat(activityName) : '操作日志';
      this.visible = true;
      this.handlerGetList();
    },
    handlerGetList: function handlerGetList() {
      var _this = this;
      this.listLoading = true;
      instantDiscountApi.instantDiscountOpLogList({
        activityId: this.currentActivityId,
        opType: this.searchPram.opType,
        startTime: this.searchPram.startTime,
        endTime: this.searchPram.endTime,
        page: this.searchPram.page,
        limit: this.searchPram.limit
      }).then(function (data) {
        _this.listData = data || {
          list: [],
          total: 0
        };
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handerSearch: function handerSearch() {
      this.searchPram.page = 1;
      this.handlerGetList();
    },
    handleReset: function handleReset() {
      this.searchPram = {
        opType: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      };
      this.dateRange = [];
      this.handlerGetList();
    },
    // 日期范围变更同步到 searchPram
    handleSizeChange: function handleSizeChange(val) {
      this.searchPram.limit = val;
      this.handlerGetList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchPram.page = val;
      this.handlerGetList();
    },
    watchDateRange: function watchDateRange() {
      var _this2 = this;
      this.$watch('dateRange', function (val) {
        if (val && val.length === 2) {
          _this2.searchPram.startTime = val[0];
          _this2.searchPram.endTime = val[1];
        } else {
          _this2.searchPram.startTime = '';
          _this2.searchPram.endTime = '';
        }
      });
    },
    /**
     * 查看按钮：触发父组件弹出日志详情弹窗（opLog 自身不关闭，双弹窗叠层显示）
     * @param {object} row 日志列表行
     * @param {'before'|'after'} side 改前/改后
     */
    handlerView: function handlerView(row, side) {
      this.$emit('go-log-detail', {
        id: row.id,
        side: side
      });
    },
    getOpTypeTag: function getOpTypeTag(opType) {
      switch (opType) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        case 4:
          return 'info';
        default:
          return '';
      }
    },
    handleClosed: function handleClosed() {
      this.searchPram = {
        opType: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      };
      this.dateRange = [];
      this.listData = {
        list: [],
        total: 0
      };
    }
  },
  created: function created() {
    this.watchDateRange();
  }
};